import { render } from "./FormResultBar.vue?vue&type=template&id=c1980716&scoped=true"
import script from "./FormResultBar.vue?vue&type=script&lang=js"
export * from "./FormResultBar.vue?vue&type=script&lang=js"

import "./FormResultBar.vue?vue&type=style&index=0&id=c1980716&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1980716"]])

export default __exports__